import { Component, inject, OnInit } from '@angular/core';
import { ModalBodyClass } from '../../../../modals/modal-body';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { DetailedModalComponent } from '../../../../modals/detailed-modal/detailed-modal.component';
import { Observable } from 'rxjs';
import { Email, EmailTemplatePreviewFieldConfig } from '../../../../shared/models/generated/ziroModels';
import { Nvp } from '../../../../shared/models/nvp';
import { SafeHtml } from '@angular/platform-browser';
import { EmailService } from '../../../shared/services/email.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailTemplatePreviewsFieldConfigResource } from '../../../shared/resources/field-config/email-template-previews-field-config.resource';
import { HtmlSanitizerService } from '../../../../shared/services/html-sanitizer.service';

@Component({
  selector: 'ziro-email-preview-detailed-modal',
  templateUrl: './email-preview-detailed-modal.component.html',
  standalone: false,
})
export class EmailPreviewDetailedModalComponent extends ModalBodyClass implements OnInit {
  protected _ziroFormStateService: ZiroFormStateService;
  private detailedModalComponent = inject<DetailedModalComponent<any>>(DetailedModalComponent);
  private activeModal = inject(NgbActiveModal);
  private emailService = inject(EmailService);
  private emailTemplatePreviewsFieldConfigResource = inject(EmailTemplatePreviewsFieldConfigResource);
  private _htmlSanitizerService = inject(HtmlSanitizerService);

  formConfig = { fields: {} };

  emailSenderName: string;
  emailRecipients: string;
  emailSubject: SafeHtml;
  emailBody: SafeHtml;

  isLoading = true;

  private _emailTemplatePreview: EmailTemplatePreviewFieldConfig;
  private _enduserUsername: string;

  ngOnInit(): void {
    this._enduserUsername = this.detailedModalComponent.modalViewProperties.enduserUsername;
    this._emailTemplatePreview = this.detailedModalComponent.modalViewProperties.emailTemplatePreview;

    if (this._emailTemplatePreview) {
      this._initView(this._emailTemplatePreview);
    } else {
      this.emailTemplatePreviewsFieldConfigResource
        .get(this._enduserUsername, this.detailedModalComponent.modalViewProperties.cucmServerId)
        .subscribe((emailTemplates) => {
          this._emailTemplatePreview = emailTemplates[0];
          this._initView(this._emailTemplatePreview);
        });
    }
  }

  private _initView(emailTemplatePreview: EmailTemplatePreviewFieldConfig): void {
    this.emailSenderName = emailTemplatePreview.senderName;
    this.emailRecipients = emailTemplatePreview.recipients.join('; ');
    this.emailSubject = this._htmlSanitizerService.sanitizeAndTrustHtml(emailTemplatePreview.emailSubject);
    this.emailBody = this._htmlSanitizerService.sanitizeAndTrustHtml(emailTemplatePreview.emailBody);
    this.isLoading = false;
  }

  submit(): Observable<void> {
    const email: Email = {
      senderName: this._emailTemplatePreview.senderName,
      recipients: this._emailTemplatePreview.recipients,
      emailSubject: this._emailTemplatePreview.emailSubject,
      emailBody: this._emailTemplatePreview.emailBody,
    };
    const audits: Nvp[] = [
      {
        name: 'templateName',
        value: this._emailTemplatePreview.emailTemplateName,
      },
      {
        name: '360ViewEnduser',
        value: this._enduserUsername,
      },
    ];
    return this.emailService.sendEmail(email, audits);
  }

  cancel(): void {
    if (!this.isSubmitting) {
      this.activeModal.dismiss();
    }
  }
}
